import React, { FC } from 'react';

import { TableRow } from '@portal/common/components';
import { DataKey, DataRecord } from '@portal/common/types';
import { localizeRecords } from '@portal/common/utility/chart-data-helpers';

import _ from '../../../locale/_';
import Cell from './Cell';
import { filterDataResponse } from './utils';

type Props = {
    columns: DataKey[];
    records: DataRecord[];
    page: number;
    showDecimals: boolean;
    valueFields: string[];
    getVisibleColumnsIdxs: (columns: DataKey[]) => number[];
};

const Rows: FC<Props> = ({
    columns,
    records,
    page,
    getVisibleColumnsIdxs,
    valueFields,
    showDecimals,
}) => {
    const localizedRecords = localizeRecords(columns, records, _);
    const { columns: filteredColumns, records: filteredRecords } = filterDataResponse(
        { columns, records: localizedRecords },
        getVisibleColumnsIdxs(columns),
        true
    );

    return filteredRecords.map((record, idx) => (
        <TableRow key={`${page}:${idx}`}>
            {record.map((value, innerIdx) => (
                <Cell
                    value={value}
                    key={innerIdx}
                    filterKey={filteredColumns[innerIdx]}
                    {...{ valueFields, showDecimals }}
                />
            ))}
        </TableRow>
    ));
};

export default Rows;
